export default name => {
  return name
    .split(" / ")
    .slice(0, -1)
    .join(" - ");
};
